import { Heading, Input, Link, Stack, Text } from "@chakra-ui/react";
import * as React from "react";
import { useForm } from "react-hook-form";
import { Link as RouterLink } from "react-router-dom";

import { createPasswordResetToken } from "../api/auth";
import { Button } from "../components/button";
import { Field } from "../components/field";
import LoginShell from "../components/login-shell";
import { toaster } from "../components/toaster";

interface RequestPasswordResetForm {
  username: string;
}

export default function RequestPasswordResetPage() {
  const [isLoading, setIsLoading] = React.useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RequestPasswordResetForm>();
  const onSubmit = handleSubmit(async ({ username }) => {
    setIsLoading(true);
    try {
      await createPasswordResetToken(username);
      toaster.create({
        type: "success",
        title: "Check Your Email",
        description: "Follow the instructions to reset your password.",
      });
    } catch (e) {
      toaster.create({
        type: "error",
        title: "Error",
        description: e.message,
      });
    } finally {
      setIsLoading(false);
    }
  });

  return (
    <LoginShell>
      <Stack color="fg.accent" gap={{ base: "2", md: "3" }} textAlign="center">
        <Heading size={{ base: "2xl", md: "3xl" }}>Reset Password</Heading>
        <Text color="fg.muted">
          Enter your email and we{"'"}ll send you a link to reset your password.
        </Text>
      </Stack>
      <form onSubmit={onSubmit}>
        <Stack gap="6">
          <Field
            label="Email"
            invalid={!!errors.username}
            errorText={errors.username?.message}
          >
            <Input
              type="email"
              placeholder="johndoe@example.com"
              {...register("username", {
                required: "Please provide an e-mail address.",
              })}
            />
          </Field>
          <Stack gap="4">
            <Button loading={isLoading} type="submit">
              Send Reset Link
            </Button>
          </Stack>

          <Text textStyle="sm" color="fg.muted" textAlign="center">
            Back to{" "}
            <Link asChild variant="underline">
              <RouterLink to="/login">Sign In</RouterLink>
            </Link>
          </Text>
        </Stack>
      </form>
    </LoginShell>
  );
}
